(function($) {
  function observeMutations(elementSelector, callback) {
    var observer = new MutationObserver(callback);
    var config = { attributes: true, childList: true, characterData: false };
    observer.observe(document.querySelector(elementSelector), config);

    return observer;
  }  
  
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

    
  function updateCartTotal(cart) {
    $('.cart--total--price').text(theme.utils.formatMoney(cart.total_price));
    $('.cart--external--total-items').text(cart.item_count);
  }

  function cartQtyUpdates(qtyUpdates) {
    var updates = {};
    qtyUpdates.forEach(function(item) {
      updates[item.key] = item.quantity;
    });

    //console.log(updates);
    return new Promise(function(resolve, reject) {
      $.post('/cart/update.js', {
        updates: updates
      }, null, 'json')
      .done(function(data) {
        resolve(data);
      });      
    });
  }
  
  function adjustBundles() {
    $.getJSON('/cart.js').then(function(cart) {
      var extraCostItems = cart.items.filter(function(item) {
        return item.properties.hasOwnProperty('__bundleId') && item.properties.hasOwnProperty('__extracost-hidden');
      });
      
      var qtyUpdates = [];
      extraCostItems.forEach(function(extraItem) {
        var bundleId = extraItem.properties.__bundleId;
        var mainItem = cart.items.filter(function(item) {
          return item.properties.__bundleId === bundleId && item.properties.hasOwnProperty('__cbdItems');
        });
        
        if (mainItem.length) {
          var cbdcount = parseInt(mainItem[0].properties.__cbdItems);
          var isQtyUpdateRequired = mainItem[0].quantity * cbdcount !== extraItem.quantity;
          if (isQtyUpdateRequired) {
            var updatedQty = mainItem[0].quantity * cbdcount;
            
            qtyUpdates.push({
              key: extraItem.key,
              quantity: updatedQty
            });
            
            $(`[data-item-key="${extraItem.key}"]`).find('.cart--quantity--input').val(updatedQty).trigger('change');
          }
        }
        else {
          qtyUpdates.push({
            key: extraItem.key,
            quantity: 0
          });
        }
      });
      
      if (qtyUpdates.length) {
        cartQtyUpdates(qtyUpdates).then(updateCartTotal);
      }
    });    
  }

  $(document).ready(function() {
    observeMutations('[data-js-class="Cart"]', function(m) {
      debounce(adjustBundles, 250)();
    });
  });
})(jQuery);